import { colors } from '../../assets/colors';
import { Text } from '../../helpers';
import { IInvoice } from '../../interfaces';
import { setGlobalState } from '../../state';
import AnimatedLoader from '../AnimatedLoader/AnimatedLoader';
import Button from '../Button/Button';
import { BankIDLogo } from '../Logos';
import Address from './Address';
import PaymentProviderFooter from './PaymentProviderFooter';
import { approveCopy, resumeStripePayment } from '../../functions/approveCopy';
import { useTranslation } from 'react-i18next';
import signInvoice, { buildSignInvoicePayload } from '../../api/signInvoice/signInvoice';

type ConfirmedUserInfoPropsType = {
    invoice: IInvoice;
    setShowInfo: React.Dispatch<React.SetStateAction<'manual' | 'confirmed' | 'start'>>;
    loading: boolean;
};

const ConfirmedUserInfo = ({ invoice, loading, setShowInfo }: ConfirmedUserInfoPropsType) => {
    const { t } = useTranslation();
    const copy = approveCopy(invoice.payment_provider);
    const resumePayment = resumeStripePayment(invoice);

    return (
        <>
            {loading && <AnimatedLoader />}
            <Text
                i={t('invoiceInformation')}
                fontWeight="normal"
                style={{ fontSize: '18px', marginBottom: '13px' }}
            />
            <Address setShowInfo={setShowInfo} />
            <Button
                i={
                    resumePayment
                        ? t('continueToPayment')
                        : t(copy.withBankID ?? 'approveWithBankID')
                }
                color={colors.white}
                fontWeight="bold"
                style={{
                    marginTop: '8%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px'
                }}
                disabled={loading}
                onClick={async () => {
                    setGlobalState('loading', true);
                    await signInvoice(
                        invoice.uuid,
                        buildSignInvoicePayload(
                            invoice,
                            resumePayment ? { needBankSignature: false } : {}
                        ),
                        invoice.payment_provider
                    );
                    setGlobalState('loading', false);
                }}
            >
                {!resumePayment && <BankIDLogo />}
            </Button>
            {!invoice.is_signing_required && !resumePayment && (
                <Button
                    i={t(copy.withoutBankID)}
                    color={colors.white}
                    fontWeight="bold"
                    style={{
                        marginTop: '8%',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px'
                    }}
                    disabled={loading}
                    onClick={async () => {
                        setGlobalState('loading', true);
                        await signInvoice(
                            invoice.uuid,
                            buildSignInvoicePayload(invoice, { needBankSignature: false }),
                            invoice.payment_provider
                        );
                        setGlobalState('loading', false);
                    }}
                />
            )}
            <PaymentProviderFooter invoice={invoice} />
        </>
    );
};

export default ConfirmedUserInfo;
